<template>
  <div id="app" class="wrapper">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import Dashboard from './components/Dashboard.vue'

// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

Vue.use(ElementUI, { locale })

export default {
  name: 'App',
  components: {
    'dashboard': Dashboard
  }
}
</script>
<style lang="scss">
  @import "sass/main"
</style>
<style lang="css">
    .modal-sm {
        width: 10%; /* responsive width */
        display: flex;
        min-height: calc(100vh - 60px);
        flex-direction: column;
        justify-content: center;
        overflow: auto;
    }
    .hr {
      color: black;
    }
    .el-table th {
      color: black;
    }
    .el-table td {
      color: black;
    }
    .el-select {
      width: 100%;
    }
    .el-form {
      padding:20px;
    }
    .el-autocomplete {
      width: 100%;
    }
    .el-dialog__title {
      font-weight: bold;
      text-transform: uppercase;
    }
    
</style>




// WEBPACK FOOTER //
// App.vue?d22365b6